module.exports = __webpack_public_path__ + "static/media/33.cf24c0b2.mp3";